import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'

class CreateBloc {

    createChannel = new Subject();
    approveChannel = new Subject();
    dinasChannel = new Subject();
    getMinDateChannel = new Subject();
    correctionTypesChannel = new Subject();
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
        this.approveChannel.next({status: apiResponse.INITIAL})
        this.dinasChannel.next({status: apiResponse.INITIAL})
        this.getMinDateChannel.next({status: apiResponse.INITIAL})
        this.correctionTypesChannel.next({status: apiResponse.INITIAL})
    }

    fetchApprove = async (query) => {
        this.approveChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchApprove(query).then((result) => {
                this.approveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.approveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Subject Unsubscribed')
        }
    }

    fetchCreate = async (query) => {
        this.createChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Subject Unsubscribed')
        }
    }

    fetchDinas = async (query) => {
        this.dinasChannel.next({status: apiResponse.LOADING})
        try {
             await this.repository.fetchDinas(query).then((result) => {
                this.dinasChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.dinasChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Subject Unsubscribed')
        }
    }

    fetchMinDate = async (query) => {
        this.getMinDateChannel.next({status: apiResponse.LOADING})
        try {
             await this.repository.fetchMinDate(query).then((result) => {
                this.getMinDateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.getMinDateChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Subject Unsubscribed')
        }
    }

    fetchCorrectionTypes = async (query) => {
        this.correctionTypesChannel.next({status: apiResponse.LOADING})
        try {
             await this.repository.fetchCorrectionTypes(query).then((result) => {
                this.correctionTypesChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.correctionTypesChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Subject Unsubscribed')
        }
    }

}

export default CreateBloc